module.exports = __webpack_public_path__ + "static/L2_visual_5_1_dont-1d05603fc7f43a827ea80f380d34dae6.png";